module.exports = __webpack_public_path__ + "static/media/79780007-xCE0wSgs.f3e9cae1.JPG";